import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useLanguage } from '../../i18n/LanguageContext';
import './Welcome.css';

const Welcome = () => {
  const { t } = useLanguage();

  return (
    <section className="welcome-section py-4">
      <div className="search-container">
        <Row className="welcome-row g-0 align-items-start">
          <Col md={5} className="welcome-image-col pe-md-3 ps-0">
            <div className="welcome-image-container">
              <img
                src="/images/tmkAtlas/sofra.png"
                alt={t('welcome.imageAlt')}
                className="welcome-image"
              />
            </div>
          </Col>
          <Col md={7} className="welcome-copy-col pe-0">
            <h2 className="welcome-title">{t('welcome.title')}</h2>
            <div className="welcome-text">
              {t('welcome.body')
                .split(/\n\s*\n/)
                .map((para) => para.trim())
                .filter(Boolean)
                .map((para, index) => (
                  <p key={index}>{para}</p>
                ))}
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default Welcome;
